import React from 'react';
import { ChakraV3 } from '../..';
import type { CommandMenuContext, TabbedPage } from './CommandMenu';
import { CommandPageContent } from './CommandPageContent';

interface Props<A> {
  page: TabbedPage<A>;
  context: CommandMenuContext<A>;
}

export const CommandTabbedPageContent = <A,>(props: Props<A>) => {
  const { page, context } = props;

  const defaultPage = page.tabs[0].pageId;

  return (
    <ChakraV3.Tabs.Root
      defaultValue={defaultPage}
      variant='subtle'
      size='sm'
      lazyMount
      unmountOnExit
    >
      <ChakraV3.Tabs.List p={1.5}>
        {page.tabs.map((tab) => (
          <ChakraV3.Tabs.Trigger
            key={`tab-trigger-${tab.pageId}`}
            value={tab.pageId}
            tabIndex={-1}
            h='1.75rem'
            data-command-menu-tab-trigger
          >
            {tab.icon?.(context)}
            {tab.label}
          </ChakraV3.Tabs.Trigger>
        ))}
      </ChakraV3.Tabs.List>
      <ChakraV3.Separator borderColor='gray.300' />
      <ChakraV3.TabsContentGroup h='full' w='full'>
        {page.tabs.map((tab) => {
          const page = context.getPage(tab.pageId);

          if (!page) {
            return null;
          }

          return (
            <ChakraV3.Tabs.Content
              key={`tab-content-${tab.pageId}`}
              value={tab.pageId}
              tabIndex={-1}
            >
              <CommandPageContent page={page} context={context} />
            </ChakraV3.Tabs.Content>
          );
        })}
      </ChakraV3.TabsContentGroup>
    </ChakraV3.Tabs.Root>
  );
};
